import { render, staticRenderFns } from "./FedExRegistration.vue?vue&type=template&id=2e8a6604&scoped=true"
import script from "./FedExRegistration.vue?vue&type=script&lang=ts"
export * from "./FedExRegistration.vue?vue&type=script&lang=ts"
import style0 from "./FedExRegistration.vue?vue&type=style&index=0&id=2e8a6604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8a6604",
  null
  
)

export default component.exports